import { Suspense, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from "../components/Hoc/PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { isUserLoggedIn } from "../store/actions/auth";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Register from "../pages/Register";
import CapchainApp from "../pages/CapchainApp";
import MintNft from "../pages/MintNft";

const Router = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  useEffect(() => {
    if (!auth.authenticate) {
      dispatch(isUserLoggedIn());
    }
  }, [auth.authenticate, dispatch]);
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path="/app" exact component={CapchainApp} />
        <Route path="/app/mintnft" exact component ={MintNft} />

        {/* <Route path="/login" exact component={Login} />
        <Route path="/register" exact component={Register} />
         */}
        <Route path="/login" exact component={CapchainApp} />
        <Route path="/register" exact component={CapchainApp} />
        <Route path="/" exact component={Home} />
      </Switch>
    </Suspense>
  );
};

export default Router;
